import axios from 'axios';
import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const getDashboardData = async (data: any, DashboardAttendance: any) => {
	const requestData = {
		fetchSectionWiseDataToken: data,
	};
	if (DashboardAttendance == 'DashboardAttendanceDetailsforAll') {
		const URL = `${API_URL}DashboardAttendanceDetailsforAll`;
		console.log('Dashboard API URL:', URL);
		console.log('Dashboard Request params:', data);
		return makeApiCall(URL, requestData);
	} else {
		const URL = `${API_URL}DashboardAttendanceDetails`;
		console.log('Dashboard API URL:', URL);
		console.log('Dashboard Request params:', data);
		return makeApiCall(URL, requestData);
	}
};

export const getDashboardEmployeeListEnhanced = async (data: any) => {
	const requestData = {
		fetchEmployeeListEnhancedKeyToken: data,
	};
	const URL = `${API_URL}DashboardEmployeeListEnhanced`;
	console.log('Enhanced Employee List API URL:', URL);
	console.log('Enhanced Employee List Request params:', requestData);
	return makeApiCall(URL, requestData);
};

export const getSectionListForDashboard = () => {
	const URL = `${API_URL}DashboardGetAllSection`;
	console.log(URL);
	return axios.get(URL);
};

// Dashboard Card Services
export const getActiveEmployeesCard = async (data: any) => {
	const requestData = {
		GetActiveEmployeesCardToken: data,
	};
	const URL = `${API_URL}GetActiveEmployeesCard`;
	return makeApiCall(URL, requestData);
};

export const getCheckedInCard = async (data: any) => {
	const requestData = {
		GetCheckedInCardToken: data,
	};
	const URL = `${API_URL}GetCheckedInCard`;
	return makeApiCall(URL, requestData);
};

export const getLateCheckInCard = async (data: any) => {
	const requestData = {
		GetLateCheckInCardToken: data,
	};
	const URL = `${API_URL}GetLateCheckInCard`;
	return makeApiCall(URL, requestData);
};

export const getEarlyCheckOutCard = async (data: any) => {
	const requestData = {
		GetEarlyCheckOutCardToken: data,
	};
	const URL = `${API_URL}GetEarlyCheckOutCard`;
	return makeApiCall(URL, requestData);
};

export const getOnLeaveCard = async (data: any) => {
	const requestData = {
		GetOnLeaveCardToken: data,
	};
	const URL = `${API_URL}GetOnLeaveCard`;
	return makeApiCall(URL, requestData);
};

export const getAbsentCard = async (data: any) => {
	const requestData = {
		GetAbsentCardToken: data,
	};
	const URL = `${API_URL}GetAbsentCard`;
	return makeApiCall(URL, requestData);
};

export const getCheckedInCardEmployeeList = async (data: any) => {
	const requestData = {
		GetCheckedInCardEmployeeListToken: data,
	};
	const URL = `${API_URL}GetCheckedInCardEmployeeList`;
	console.log('Checked In Card Employee List API URL:', URL);
	console.log('Checked In Card Employee List Request params:', requestData);
	return makeApiCall(URL, requestData);
};

export const getActiveEmployeesCardEmployeeList = async (data: any) => {
	const requestData = {
		GetActiveEmployeesCardEmployeeListToken: data,
	};
	const URL = `${API_URL}GetActiveEmployeesCardEmployeeList`;
	return makeApiCall(URL, requestData);
};

export const getLateCheckInCardEmployeeList = async (data: any) => {
	const requestData = {
		GetLateCheckInCardEmployeeListToken: data,
	};
	const URL = `${API_URL}GetLateCheckInCardEmployeeList`;
	return makeApiCall(URL, requestData);
};

export const getEarlyCheckOutCardEmployeeList = async (data: any) => {
	const requestData = {
		GetEarlyCheckOutCardEmployeeListToken: data,
	};
	const URL = `${API_URL}GetEarlyCheckOutCardEmployeeList`;
	return makeApiCall(URL, requestData);
};

export const getOnLeaveCardEmployeeList = async (data: any) => {
	const requestData = {
		GetOnLeaveCardEmployeeListToken: data,
	};
	const URL = `${API_URL}GetOnLeaveCardEmployeeList`;
	return makeApiCall(URL, requestData);
};

export const getAbsentCardEmployeeList = async (data: any) => {
	const requestData = {
		GetAbsentCardEmployeeListToken: data,
	};
	const URL = `${API_URL}GetAbsentCardEmployeeList`;
	return makeApiCall(URL, requestData);
};